// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"7629057d","496":"4ea707b2","498":"665942f3","513":"c29ab2cd"}[chunkId] + ".chunk.js";
};